export class HrPrfUnitTypeKey {
    private static readonly keyPrefix = 'hrPrfUnitType';
    public static title = `${HrPrfUnitTypeKey.keyPrefix}.title`;
    public static pageHeader = `${HrPrfUnitTypeKey.keyPrefix}.pageHeader`;
    public static selectable = `${HrPrfUnitTypeKey.keyPrefix}.selectable`;
    public static shortText = `${HrPrfUnitTypeKey.keyPrefix}.shortText`;
    public static longText = `${HrPrfUnitTypeKey.keyPrefix}.longText`;
    public static selectableDropDown = `${HrPrfUnitTypeKey.keyPrefix}.selectableDropDown`;
}
